import {
  ListingCompany,
  ListingContact,
  ListingDefaultsFormValues,
  ListingOffice,
  ListingTemplate,
  ListingTemplateFormValues,
  UpdateListingDefaultsRequest,
  UpdateListingTemplateRequest,
} from "./types";

const s = (v: string | null | undefined): string => (v == null ? "" : String(v));
const orNull = (v: string): string | null => (v.trim() === "" ? null : v);

// Kontakt i poslovnice rezolvira backend — FE ih samo normalizira u stringove.
export const transformListingContact = (res: any): ListingContact => ({
  userId: s(res?.userId),
  fullName: s(res?.fullName),
  email: s(res?.email),
  phoneNumber: s(res?.phoneNumber),
  mobilePhoneNumber: s(res?.mobilePhoneNumber),
});

export const transformListingOffice = (res: any): ListingOffice => ({
  officeId: s(res?.officeId),
  name: s(res?.name),
  address: s(res?.address),
  city: s(res?.city),
  latitude: res?.latitude ?? null,
  longitude: res?.longitude ?? null,
});

export const transformListingCompany = (res: any): ListingCompany => ({
  name: s(res?.name),
  logoUrl: s(res?.logoUrl),
});

export const transformListingDefaults = (res: any): ListingDefaultsFormValues => ({
  contactUserIds: res?.contactUserIds ?? [],
  locationOfficeIds: res?.locationOfficeIds ?? [],
  contacts: (res?.contacts ?? []).map(transformListingContact),
  offices: (res?.offices ?? []).map(transformListingOffice),
  locationCountyCode: s(res?.locationCountyCode),
  locationMunicipalityCode: s(res?.locationMunicipalityCode),
  locationSettlementCode: s(res?.locationSettlementCode),
  locationManualAddress: s(res?.locationManualAddress),
  locationDisplay: res?.locationDisplay === "exact" ? "exact" : "approximate",
  priceIncludesImport:
    res?.priceIncludesImport === "with" || res?.priceIncludesImport === "without"
      ? res.priceIncludesImport
      : "",
  paymentOptions: res?.paymentOptions ?? {},
  warrantyCode: s(res?.warrantyCode),
  extendedWarranty: !!res?.extendedWarranty,
  g1ClubWarranty: !!res?.g1ClubWarranty,
  videoCallViewing: !!res?.videoCallViewing,
});

export const transformListingDefaultsOnUpdate = (
  formValues: ListingDefaultsFormValues
): UpdateListingDefaultsRequest => ({
  contactUserIds: formValues.contactUserIds,
  locationOfficeIds: formValues.locationOfficeIds,
  locationCountyCode: orNull(formValues.locationCountyCode),
  locationMunicipalityCode: orNull(formValues.locationMunicipalityCode),
  locationSettlementCode: orNull(formValues.locationSettlementCode),
  locationManualAddress: orNull(formValues.locationManualAddress),
  locationDisplay: formValues.locationDisplay,
  priceIncludesImport: formValues.priceIncludesImport === "" ? null : formValues.priceIncludesImport,
  paymentOptions: formValues.paymentOptions,
  warrantyCode: orNull(formValues.warrantyCode),
  extendedWarranty: formValues.extendedWarranty,
  g1ClubWarranty: formValues.g1ClubWarranty,
  videoCallViewing: formValues.videoCallViewing,
});

export const transformListingTemplate = (res: any): ListingTemplate => ({
  id: s(res?.id),
  name: s(res?.name),
  titleTemplate: s(res?.titleTemplate),
  descriptionTemplate: s(res?.descriptionTemplate),
  isDefault: !!res?.isDefault,
});

export const transformListingTemplateOnUpdate = (
  formValues: ListingTemplateFormValues
): UpdateListingTemplateRequest => ({
  name: orNull(formValues.name),
  titleTemplate: orNull(formValues.titleTemplate),
  descriptionTemplate: orNull(formValues.descriptionTemplate),
  isDefault: formValues.isDefault,
});
